import { useDispatch } from 'react-redux'
import { Button } from 'components'
import { STATICS } from 'statics'
import { setStage } from 'slices/drawer'
import { NEW_VIRTUAL_SUPPORT_STAGES } from 'app-constants'
import { SignalInfo } from '../signal-info'
import './style.scss'

export function UnstableSignal() {
  const dispatch = useDispatch()

  function handleStartClick() {
    dispatch(setStage(NEW_VIRTUAL_SUPPORT_STAGES.MODEM_RESET))
  }

  function handleEquipmentInfoClick() {
    dispatch(setStage(NEW_VIRTUAL_SUPPORT_STAGES.MODEM_EQUIPMENT_LIST))
  }

  return (
    <div className='unstable-signal'>
      <SignalInfo
        icon={STATICS.SIGNAL_WARNING}
        iconAlt='Sinal de internet instável'
        title='Sinal instável'
      >
        <p>Sua rede está enfrentando alguns problemas de conexão.</p>
        <p>
          Para isso, vamos realizar alguns procedimentos no modem da sua internet para reiniciar a
          rede.
        </p>
      </SignalInfo>
      <div className='actions-container'>
        <Button className='button-component -large' color='primary' onClick={handleStartClick}>
          Vamos lá
        </Button>
        <Button
          className='button-component -large'
          color='primary'
          outlined
          onClick={handleEquipmentInfoClick}
        >
          Acessar a lista de equipamentos
        </Button>
      </div>
    </div>
  )
}
